module.exports = "/remote-dist/5541abae1a54b6f9d766818f90b14048.png";